<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ 'NEWS' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="flex flex-column gap-8">
      @for (newsEntry of news(); track newsEntry.id) {
        <sfg-app-mitteilungen-card [news]="newsEntry" [showText]="true" />
      }
    </div>
  </div>
</ion-content>
